import React from "react";

import { styled } from '@mui/material/styles';

import Button from "@mui/material/Button";
import MuiDialog from "@mui/material/Dialog";
import MuiDialogActions from "@mui/material/DialogActions";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogTitle from "@mui/material/DialogTitle";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const VatDialog = ({
  children,
  handler,
  handleClose,
  id,
  open,
  title,
  confirmationButtonText
}) => {
  const { t } = useTranslation();
  if (confirmationButtonText === undefined) {
    confirmationButtonText = t("businessPartnerDetailsPage.vatDialog.confirmationButtonText")
  }

  return (
    <MuiDialog
      aria-labelledby={id}
      fullWidth={true}
      onClose={handleClose}
      open={open}
      PaperProps={{ elevation: 1 }}
    >
      <StyledMuiDialogTitle id={id}>
        <StyledTitleTypography component="p" variant="h4">
          {title}
        </StyledTitleTypography>

        <IconButton aria-label="Close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </StyledMuiDialogTitle>

      <StyledContent>
        {children}

      </StyledContent>

      <StyledMuiDialogActions>
        <Button
          // eslint-disable-next-line jsx-a11y/no-autofocus
          autoFocus
          sx={{ width: 120 }}
          onClick={handler}
          color="primary"
          type="button"
        >
          {confirmationButtonText}
        </Button>

        <Button
          sx={{ width: 120 }}
          color="secondary"
          onClick={handleClose}
        >
          {t("businessPartnerDetailPage.vatDialog.cancelButton")}
        </Button>
      </StyledMuiDialogActions>
    </MuiDialog>
  );
};
const StyledMuiDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  height: 60,
  justifyContent: "space-between",
  padding: theme.spacing(2),
}));
const StyledTitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
}));
const StyledContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2, 2, 0),
}));
const StyledMuiDialogActions = styled(MuiDialogActions)(({ theme }) => ({
  padding: theme.spacing(3, 2, 4),
}));

export default VatDialog;